"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = exports["default"] = exports.AmountPriceContainer = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _AmountPrice = _interopRequireDefault(require("../../../Shared/Containers/AmountPrice"));
var _ProductVariant = _interopRequireDefault(require("../../../Shared/Containers/ProductVariant"));
var _ConfigurationModeSwitch = _interopRequireDefault(require("./ConfigurationModeSwitch"));
var _styles = require("@material-ui/core/styles");
var _excluded = ["AmountPriceContainer", "showDesigner"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var useStyles = exports.useStyles = (0, _styles.makeStyles)(function (theme) {
  var _root;
  return {
    root: (_root = {
      bottom: 0,
      right: 0,
      position: 'absolute'
    }, _defineProperty(_root, theme.breakpoints.down('xs'), {
      right: 0,
      left: 0
    }), _defineProperty(_root, theme.breakpoints.between('xs', 'sm'), {
      width: '100%'
    }), _defineProperty(_root, theme.breakpoints.between('sm', 'xl'), {
      width: '320px'
    }), _root)
  };
}, {
  name: 'AmountPrice'
});
var AmountPriceContainer = exports.AmountPriceContainer = function AmountPriceContainer(_ref) {
  var AmountPriceContainer = _ref.AmountPriceContainer,
    showDesigner = _ref.showDesigner,
    props = _objectWithoutProperties(_ref, _excluded);
  var classes = useStyles({
    showDesigner: showDesigner
  });
  var wrapperRoot = showDesigner ? '' : classes.root;
  return /*#__PURE__*/_react["default"].createElement(AmountPriceContainer, _extends({
    wrapperClass: wrapperRoot
  }, props));
};
AmountPriceContainer.defaultProps = {
  AmountPriceContainer: _AmountPrice["default"],
  ProductVariantComponent: _ProductVariant["default"],
  ConfigurationModeSwitchComponent: _ConfigurationModeSwitch["default"],
  showConfigurationModeSwitch: false,
  showDesigner: false
};
var _default = exports["default"] = AmountPriceContainer;